let $ = require("jquery");
let Backbone = require("backbone");
let _ = require("underscore");
import POS from "../../POS.js";
import i18n from "../../utils/i18n";
let HB = require("handlebars");
import MembershipView from "./MembershipView.js";
import MembershipSchemeView from "./MembershipSchemeView.js";

let main = function () {
    return Backbone.View.extend({

        events: {
            "click li.membership": "onSelectMembership",
            "click li.scheme": "onSelectScheme"
        },

        initialize: function (options) {
            this.rId = this.$el.data("id");
            //this.featureListView = new FeatureListView({el: this.$(".subContent"), model: new Backbone.Model({organizationId: this.rId})});
            this.membershipView = new MembershipView({el: this.$(".membership-container"), model: new Backbone.Model({organizationId: this.rId})});
//                this.membershipSchemeView = new MembershipSchemeView({el: this.$(".scheme-container")});
        },

        render: function () {
            this.membershipView.tooltips = this.tooltips;
//                this.membershipSchemeView.tooltips = this.tooltips;
            this.membershipView.render();
//                this.membershipSchemeView.render();
            return this;
        },

        onSelectMembership: function (event) {
            this.$("li.tab").removeClass("active");
            this.$("li.tab.membership").addClass("active");
            this.$(".membership-container").removeClass("hidden");
            this.$(".scheme-container").addClass("hidden");
            this.membershipView.render();
        },

        onSelectScheme: function (event) {
            this.$("li.tab").removeClass("active");
            this.$("li.tab.scheme").addClass("active");
            this.$(".scheme-container").removeClass("hidden");
            this.$(".membership-container").addClass("hidden");
//                this.membershipSchemeView.render();
        }
    });
};

let exportedValue = main();
export default exportedValue;



// WEBPACK FOOTER //
// ./src/view/settings/MembershipSettingView.js